module.exports = __webpack_public_path__ + "static/media/step2.4200d2fa.svg";